<div class="balance-visit-row" data-balance-summary-visit>
  <div class="balance-visit-row__summary">
    <span class="balance-visit-row__label-cell">
      <span class="balance-visit-row__label-line">
        @if (chargeCount() > 0) {
          <button
            mat-icon-button
            color="primary"
            type="button"
            class="balance-visit-row__breakdown-action"
            data-testid="visit-row-breakdown-open"
            [matTooltip]="'balance.review.breakdown.open' | translate"
            [attr.aria-label]="'balance.review.breakdown.open' | translate"
            (click)="openChargeBreakdown()"
          >
            <mat-icon>price_check</mat-icon>
          </button>
        }

        <span class="balance-visit-row__label" data-testid="visit-row-label">
          {{ labelKey() | translate: { number: row().visitNumber, dateTime: row().appointmentStartAt | date: dateFormat } }}
        </span>

        @if (row().cptCodes.length > 0) {
          <span
            class="balance-visit-row__cpts"
            data-testid="visit-row-cpts"
            [attr.title]="row().cptCodesJoined"
          >
            {{ row().cptCodesPreview }}
            @if (row().additionalCptCodeCount > 0) {
              <span>
                {{ 'balance.review.breakdown.more-codes' | translate: { count: row().additionalCptCodeCount } }}
              </span>
            }
          </span>
        }

        @if (diff() === 'new') {
          <span
            class="balance-visit-row__badge balance-visit-row__badge--new"
            data-testid="visit-row-badge-new"
          >{{ 'balance.modify-session.diff.new-badge' | translate }}</span>
        }

        @if (diff() === 'renumbered') {
          <span
            class="balance-visit-row__badge balance-visit-row__badge--renumbered"
            data-testid="visit-row-badge-renumbered"
          >{{ 'balance.modify-session.diff.renumbered-badge' | translate: { old: renumberedFrom(), new: row().visitNumber } }}</span>
        }

        @if (row().hasPbTrace || row().hasHbTrace) {
          <span class="balance-visit-row__traces">
            @if (row().hasPbTrace) {
              <button
                mat-icon-button
                color="primary"
                type="button"
                class="balance-visit-row__trace-button"
                data-testid="visit-row-pb-trace"
                (click)="onPbTrace()"
                [matTooltip]="'patient-details.estimate-card.advanced.pb-trace-link' | translate"
                [attr.aria-label]="'patient-details.estimate-card.advanced.pb-trace-link' | translate"
              >
                <mat-icon>receipt_long</mat-icon>
              </button>
            }
            @if (row().hasHbTrace) {
              <button
                mat-icon-button
                color="primary"
                type="button"
                class="balance-visit-row__trace-button"
                data-testid="visit-row-hb-trace"
                (click)="onHbTrace()"
                [matTooltip]="'patient-details.estimate-card.advanced.hb-trace-link' | translate"
                [attr.aria-label]="'patient-details.estimate-card.advanced.hb-trace-link' | translate"
              >
                <mat-icon>receipt_long</mat-icon>
              </button>
            }
          </span>
        }
      </span>

      @if (row().cptDiscountApplied < 0 || row().charityCareDiscountApplied > 0) {
        <span class="balance-visit-row__discounts">
          @if (row().cptDiscountApplied < 0) {
            <span
              class="balance-visit-row__discount"
              data-testid="visit-row-discount"
            >{{ 'balance.review.discount-label' | translate }} {{ row().cptDiscountApplied | currency }}</span>
          }

          @if (row().charityCareDiscountApplied > 0) {
            <span
              class="balance-visit-row__discount"
              data-testid="visit-row-charity-care-discount"
            >{{ 'balance.review.charity-care-discount-label' | translate }} -{{ row().charityCareDiscountApplied | currency }}</span>
          }
        </span>
      }
    </span>

    <span
      class="balance-visit-row__amount balance-visit-row__amount--patient patient-resp-amount"
      data-testid="visit-row-amount"
    >{{ row().patientResp | currency }}</span>

    <span
      class="balance-visit-row__amount balance-visit-row__amount--insurance"
      data-testid="visit-row-amount"
    >{{ row().insuranceResp | currency }}</span>

    <span
      class="balance-visit-row__amount balance-visit-row__amount--total"
      data-testid="visit-row-amount"
    >{{ row().total | currency }}</span>
  </div>

</div>
